import { buildUrl, handleResponse } from "./auth";

const parseFileName = (response) => {
  const disposition = response.headers.get("content-disposition") || "";
  const match = disposition.match(/filename="?([^";]+)"?/i);
  return match?.[1] || null;
};

export const listReceipts = () =>
  fetch(buildUrl("/api/receipts"), { credentials: "include" }).then(handleResponse);

export const downloadReceipt = async (bookingId) => {
  const response = await fetch(buildUrl(`/api/receipts/${bookingId}`), { credentials: "include" });
  if (!response.ok) {
    const message = await response.text().catch(() => "");
    throw new Error(message || "Failed to download receipt.");
  }
  const blob = await response.blob();
  return { blob, fileName: parseFileName(response) };
};
